var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"heading"},[_vm._v("Help Resources for User")]),_c('br'),_c('section',{domProps:{"innerHTML":_vm._s(_vm.helpTemplate)}})])}
var staticRenderFns = []
export { render, staticRenderFns }